import { ConversationGroupType, ConversationHistoryType, SortedConversationHistoryType } from "../aiComponent";

export function convertToDate(input: string): string | Error {
    try {
      // Check if the input string is in the expected format
      const isoDateRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d+\+\d{2}:\d{2}$/;
      if (!isoDateRegex.test(input)) {
        throw new Error("Input string format is incorrect. Expected format: YYYY-MM-DDTHH:MM:SS.ssssss+HH:MM");
      }
  
      // Parse the string to a Date object
      const date = new Date(input);
      
      // Check if the date is valid
      if (isNaN(date.getTime())) {
        throw new Error("Invalid date.");
      }
  
      // Format the date to "YYYY-MM-DD HH:MM"
      const year = date.getFullYear().toString();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');
  
      return `${year}-${month}-${day} ${hours}:${minutes}`;
    } catch (error) {
      // Return the error object in a real-world scenario, you might want to log these errors
      if (error instanceof Error) {
        return error;
      }
      return new Error("An unknown error occurred.");
    }
  }

export const getRandomNumber = (n: number): number => {
  return Math.floor(Math.random() * n); // Generates a random number between 0 and 2
};

export function getGroupName(id: ConversationGroupType): string {

  switch(id){
    case "today":
      return "Idag";
    case "yesterday":
      return "Igår";
    case "last7Days":
      return "Senaste 7 dagarna";
    case "last30days":
      return "Senaste 30 dagarna";
    case "older":
      return "Äldre";
    default:
      return "";
  }

}

export function groupConversationsByLatestActivity(conversations: Array<ConversationHistoryType>): Array<SortedConversationHistoryType> {
  const now = new Date();
  const groups: { [key in ConversationGroupType]: Array<ConversationHistoryType> } = {
      today: [],
      last30days: [],
      older: []
  };

  conversations.forEach((conversation) => {
      const activityDate = new Date(conversation.LatestActivity);
      const timeDiff = now.getTime() - activityDate.getTime();
      const dayDiff = timeDiff / (1000 * 3600 * 24);

      if (dayDiff < 1 && activityDate.getDate() === now.getDate()) {
          groups.today.push(conversation);
      } else if (dayDiff <= 31) {
          groups.last30days.push(conversation);
      } else {
          groups.older.push(conversation);
      }
  });

  return Object.entries(groups)
      .filter(([, data]) => data.length > 0)
      .map(([groupName, data]) => ({
          groupName: groupName as ConversationGroupType,
          data
      }));
}